import { useMatches } from "react-router-dom";

/**
 * The "Firm" heading of the `/firm/*` pages. A route whose handle sets
 * `hideFirmHeading` shows its own heading instead, as the security's page
 * does (APP-1486).
 */
const FirmHeading = () => {
  const matches = useMatches();
  const hidden = matches.some(
    (match) =>
      (match.handle as { hideFirmHeading?: boolean } | undefined)
        ?.hideFirmHeading === true,
  );
  return hidden ? null : <h1>Firm</h1>;
};

export default FirmHeading;
